(function () {
  'use strict';

  var loader = document.currentScript;
  if (!loader || window.__lbxCatalogLoaderStarted) return;
  window.__lbxCatalogLoaderStarted = true;

  var ua = navigator.userAgent || '';
  var platform = navigator.platform || '';
  var width = window.innerWidth || document.documentElement.clientWidth || 0;
  var height = window.innerHeight || document.documentElement.clientHeight || 0;
  var shortest = Math.min(width, height);
  var longest = Math.max(width, height);
  var isIPad = /iPad/i.test(ua) || (platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  var isTouchTablet = coarse && shortest >= 700 && longest <= 1400;
  var isTabletViewport = shortest >= 700 && shortest <= 1100 && longest >= 900 && longest <= 1400;
  var useLightEngine = document.documentElement.classList.contains('lbx-ipad') || isIPad || isTouchTablet || isTabletViewport;
  var source = useLightEngine ? loader.getAttribute('data-lbx-catalog-ipad-src') : loader.getAttribute('data-lbx-catalog-standard-src');

  if (useLightEngine) {
    document.documentElement.classList.add('lbx-ipad');
    if (!document.documentElement.hasAttribute('data-lbx-ipad-mode')) {
      document.documentElement.setAttribute('data-lbx-ipad-mode', isIPad ? 'device' : (isTouchTablet ? 'touch' : 'viewport'));
    }
  }
  if (!source) return;

  var script = document.createElement('script');
  script.src = source;
  script.async = false;
  script.setAttribute('data-lbx-catalog-engine', useLightEngine ? 'ipad' : 'standard');
  document.head.appendChild(script);
})();
